import { FC } from 'react'
import { Flex, Text, Box } from 'components/primitives'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

interface MarketplaceFilterProps {
  selectedMarketplace: string | null
  setSelectedMarketplace: (marketplace: string | null) => void
}

const marketplaces = [
  {
    id: 'opensea.io',
    name: 'Opensea',
    icon: 'https://raw.githubusercontent.com/reservoirprotocol/assets/main/sources/opensea-logo.svg',
  },
  { id: 'nftx.io', name: 'NFTX', icon: 'https://nftx.io/apple-touch-icon.png' },
  { id: 'blur.io', name: 'Blur', icon: 'https://blur.io/favicons/180.png' },
  {
    id: 'sudoswap.xyz',
    name: 'SudoSwap',
    icon: 'https://sudoswap.xyz/assets/favicon/apple-touch-icon.png',
  },
  {
    id: 'magiceden.io',
    name: 'Magic Eden',
    icon: 'https://raw.githubusercontent.com/reservoirprotocol/assets/main/sources/magiceden-logo.svg',
  },
]
export const MarketplaceFilter: FC<MarketplaceFilterProps> = ({
  selectedMarketplace,
  setSelectedMarketplace,
}) => {
  const toggleMarketplace = (marketplaceId: string) => {
    if (selectedMarketplace === marketplaceId) {
      setSelectedMarketplace(null)
    } else {
      setSelectedMarketplace(marketplaceId)
    }
  }

  return (
    <Box css={{ display: 'flex', justifyContent: 'center' }}>
      <Flex direction="row" css={{ gap: '$2' }}>
        {marketplaces.map((marketplace) => {
          const isActive =
            !selectedMarketplace || selectedMarketplace === marketplace.id
          return (
            <Flex
              key={marketplace.id}
              align="center"
              css={{
                cursor: 'pointer',
                opacity: isActive ? 1 : 0.5,
                transition: 'opacity 0.2s',
                '&:hover': { opacity: isActive ? 0.8 : 0.5 },
              }}
              onClick={() => toggleMarketplace(marketplace.id)}
            >
              <Box
                css={{
                  width: 20,
                  height: 20,
                  borderRadius: 4,
                  mr: '$2',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                }}
              >
                <img
                  src={marketplace.icon}
                  alt={marketplace.name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    filter: isActive ? 'none' : 'grayscale(100%)',
                  }}
                />
              </Box>
            </Flex>
          )
        })}
      </Flex>
    </Box>
  )
}

export default MarketplaceFilter
